import { Course, User } from '../types';

// Mock instructor users
const mockInstructors: User[] = [
  {
    id: 1,
    username: "sarah_johnson",
    email: "sarah.johnson@example.com",
    first_name: "Sarah",
    last_name: "Johnson",
    profile: {
      user_type: "instructor",
      bio: "Senior JavaScript developer with 8+ years of experience",
      profile_picture: undefined,
      date_of_birth: "1985-03-15",
      phone_number: "+1-555-0123",
      created_at: "2020-01-15T10:00:00Z",
      updated_at: "2024-01-15T10:00:00Z"
    }
  },
  {
    id: 2,
    username: "michael_chen",
    email: "michael.chen@example.com",
    first_name: "Michael",
    last_name: "Chen",
    profile: {
      user_type: "instructor",
      bio: "React expert and full-stack developer",
      profile_picture: undefined,
      date_of_birth: "1988-07-22",
      phone_number: "+1-555-0124",
      created_at: "2020-02-10T10:00:00Z",
      updated_at: "2024-01-10T10:00:00Z"
    }
  },
  {
    id: 3,
    username: "david_wilson",
    email: "david.wilson@example.com",
    first_name: "David",
    last_name: "Wilson",
    profile: {
      user_type: "instructor",
      bio: "Cybersecurity specialist and web security expert",
      profile_picture: undefined,
      date_of_birth: "1982-11-08",
      phone_number: "+1-555-0125",
      created_at: "2020-03-20T10:00:00Z",
      updated_at: "2024-01-20T10:00:00Z"
    }
  },
  {
    id: 4,
    username: "lisa_rodriguez",
    email: "lisa.rodriguez@example.com",
    first_name: "Lisa",
    last_name: "Rodriguez",
    profile: {
      user_type: "instructor",
      bio: "Agile coach and project management consultant",
      profile_picture: undefined,
      date_of_birth: "1987-04-12",
      phone_number: "+1-555-0126",
      created_at: "2020-01-05T10:00:00Z",
      updated_at: "2024-01-05T10:00:00Z"
    }
  },
  {
    id: 5,
    username: "james_brown",
    email: "james.brown@example.com",
    first_name: "James",
    last_name: "Brown",
    profile: {
      user_type: "instructor",
      bio: "Mobile app developer specializing in Android",
      profile_picture: undefined,
      date_of_birth: "1989-09-30",
      phone_number: "+1-555-0127",
      created_at: "2020-02-12T10:00:00Z",
      updated_at: "2024-01-12T10:00:00Z"
    }
  },
  {
    id: 6,
    username: "emily_davis",
    email: "emily.davis@example.com",
    first_name: "Emily",
    last_name: "Davis",
    profile: {
      user_type: "instructor",
      bio: "Angular framework expert and frontend architect",
      profile_picture: undefined,
      date_of_birth: "1986-12-05",
      phone_number: "+1-555-0128",
      created_at: "2020-01-08T10:00:00Z",
      updated_at: "2024-01-08T10:00:00Z"
    }
  },
  {
    id: 7,
    username: "robert_taylor",
    email: "robert.taylor@example.com",
    first_name: "Robert",
    last_name: "Taylor",
    profile: {
      user_type: "instructor",
      bio: "AI researcher and machine learning specialist",
      profile_picture: undefined,
      date_of_birth: "1983-06-18",
      phone_number: "+1-555-0129",
      created_at: "2020-03-18T10:00:00Z",
      updated_at: "2024-01-18T10:00:00Z"
    }
  },
  {
    id: 8,
    username: "maria_garcia",
    email: "maria.garcia@example.com",
    first_name: "Maria",
    last_name: "Garcia",
    profile: {
      user_type: "instructor",
      bio: "Brand identity designer and creative director",
      profile_picture: undefined,
      date_of_birth: "1984-08-25",
      phone_number: "+1-555-0130",
      created_at: "2020-01-14T10:00:00Z",
      updated_at: "2024-01-14T10:00:00Z"
    }
  },
  {
    id: 9,
    username: "thomas_anderson",
    email: "thomas.anderson@example.com",
    first_name: "Thomas",
    last_name: "Anderson",
    profile: {
      user_type: "instructor",
      bio: "Business analyst and data science consultant",
      profile_picture: undefined,
      date_of_birth: "1981-02-14",
      phone_number: "+1-555-0131",
      created_at: "2020-02-22T10:00:00Z",
      updated_at: "2024-01-22T10:00:00Z"
    }
  },
  {
    id: 10,
    username: "jennifer_lee",
    email: "jennifer.lee@example.com",
    first_name: "Jennifer",
    last_name: "Lee",
    profile: {
      user_type: "instructor",
      bio: "Business strategy consultant and growth expert",
      profile_picture: undefined,
      date_of_birth: "1988-10-03",
      phone_number: "+1-555-0132",
      created_at: "2020-01-16T10:00:00Z",
      updated_at: "2024-01-16T10:00:00Z"
    }
  }
];

// Helper function to create mock lessons
const createMockLessons = (courseId: number, totalLessons: number) => {
  const lessons = [];
  for (let i = 1; i <= totalLessons; i++) {
    lessons.push({
      id: courseId * 100 + i,
      title: `Lesson ${i}: Introduction to ${i === 1 ? 'the Course' : 'Advanced Concepts'}`,
      video_url: `https://example.com/videos/course-${courseId}/lesson-${i}.mp4`,
      materials: `https://example.com/materials/course-${courseId}/lesson-${i}.pdf`,
      order: i,
      created_at: "2024-01-01T10:00:00Z",
      updated_at: "2024-01-01T10:00:00Z"
    });
  }
  return lessons;
};

export const mockCourses: Course[] = [
  {
    id: 1,
    title: "Advanced JavaScript Patterns",
    description: "Master advanced JavaScript concepts and design patterns for professional development",
    instructor: mockInstructors[0],
    category: "programming",
    difficulty: "advanced",
    thumbnail: undefined,
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
    lessons: createMockLessons(1, 24),
    total_lessons: 24,
    total_enrollments: 15420
  },
  {
    id: 2,
    title: "Advanced React Development",
    description: "Deep dive into React hooks, context, and advanced state management",
    instructor: mockInstructors[1],
    category: "programming",
    difficulty: "advanced",
    thumbnail: undefined,
    created_at: "2024-01-10T10:00:00Z",
    updated_at: "2024-01-10T10:00:00Z",
    lessons: createMockLessons(2, 32),
    total_lessons: 32,
    total_enrollments: 18950
  },
  {
    id: 3,
    title: "Advanced Web Security",
    description: "Learn advanced security techniques for web applications",
    instructor: mockInstructors[2],
    category: "programming",
    difficulty: "advanced",
    thumbnail: undefined,
    created_at: "2024-01-20T10:00:00Z",
    updated_at: "2024-01-20T10:00:00Z",
    lessons: createMockLessons(3, 28),
    total_lessons: 28,
    total_enrollments: 12340
  },
  {
    id: 4,
    title: "Agile Project Management",
    description: "Master agile methodologies and project management best practices",
    instructor: mockInstructors[3],
    category: "business",
    difficulty: "intermediate",
    thumbnail: undefined,
    created_at: "2024-01-05T10:00:00Z",
    updated_at: "2024-01-05T10:00:00Z",
    lessons: createMockLessons(4, 18),
    total_lessons: 18,
    total_enrollments: 9870
  },
  {
    id: 5,
    title: "Android App Development",
    description: "Build native Android applications using Kotlin and Android Studio",
    instructor: mockInstructors[4],
    category: "programming",
    difficulty: "intermediate",
    thumbnail: undefined,
    created_at: "2024-01-12T10:00:00Z",
    updated_at: "2024-01-12T10:00:00Z",
    lessons: createMockLessons(5, 26),
    total_lessons: 26,
    total_enrollments: 15670
  },
  {
    id: 6,
    title: "Angular Framework Mastery",
    description: "Complete guide to building scalable applications with Angular",
    instructor: mockInstructors[5],
    category: "programming",
    difficulty: "intermediate",
    thumbnail: undefined,
    created_at: "2024-01-08T10:00:00Z",
    updated_at: "2024-01-08T10:00:00Z",
    lessons: createMockLessons(6, 30),
    total_lessons: 30,
    total_enrollments: 13450
  },
  {
    id: 7,
    title: "Artificial Intelligence Basics",
    description: "Introduction to AI concepts, machine learning, and neural networks",
    instructor: mockInstructors[6],
    category: "programming",
    difficulty: "beginner",
    thumbnail: undefined,
    created_at: "2024-01-18T10:00:00Z",
    updated_at: "2024-01-18T10:00:00Z",
    lessons: createMockLessons(7, 22),
    total_lessons: 22,
    total_enrollments: 22340
  },
  {
    id: 8,
    title: "Brand Identity Design",
    description: "Create compelling brand identities and visual systems",
    instructor: mockInstructors[7],
    category: "design",
    difficulty: "intermediate",
    thumbnail: undefined,
    created_at: "2024-01-14T10:00:00Z",
    updated_at: "2024-01-14T10:00:00Z",
    lessons: createMockLessons(8, 20),
    total_lessons: 20,
    total_enrollments: 8760
  },
  {
    id: 9,
    title: "Business Analytics Fundamentals",
    description: "Learn data analysis techniques for business decision making",
    instructor: mockInstructors[8],
    category: "business",
    difficulty: "beginner",
    thumbnail: undefined,
    created_at: "2024-01-22T10:00:00Z",
    updated_at: "2024-01-22T10:00:00Z",
    lessons: createMockLessons(9, 16),
    total_lessons: 16,
    total_enrollments: 15670
  },
  {
    id: 10,
    title: "Business Strategy Development",
    description: "Develop comprehensive business strategies for growth and success",
    instructor: mockInstructors[9],
    category: "business",
    difficulty: "advanced",
    thumbnail: undefined,
    created_at: "2024-01-16T10:00:00Z",
    updated_at: "2024-01-16T10:00:00Z",
    lessons: createMockLessons(10, 24),
    total_lessons: 24,
    total_enrollments: 11230
  }
];

// Additional mock courses with proper structure
export const additionalMockCourses: Course[] = [
  {
    id: 11,
    title: "C++ Programming Fundamentals",
    description: "Master C++ programming from basics to advanced concepts",
    instructor: mockInstructors[0],
    category: "programming",
    difficulty: "intermediate",
    thumbnail: undefined,
    created_at: "2024-01-11T10:00:00Z",
    updated_at: "2024-01-11T10:00:00Z",
    lessons: createMockLessons(11, 28),
    total_lessons: 28,
    total_enrollments: 14320
  },
  {
    id: 12,
    title: "Content Marketing Strategy",
    description: "Develop effective content marketing strategies for digital growth",
    instructor: mockInstructors[1],
    category: "marketing",
    difficulty: "intermediate",
    thumbnail: undefined,
    created_at: "2024-01-19T10:00:00Z",
    updated_at: "2024-01-19T10:00:00Z",
    lessons: createMockLessons(12, 18),
    total_lessons: 18,
    total_enrollments: 9870
  },
  {
    id: 13,
    title: "CSS Grid and Flexbox Mastery",
    description: "Master modern CSS layout techniques with Grid and Flexbox",
    instructor: mockInstructors[2],
    category: "programming",
    difficulty: "beginner",
    thumbnail: undefined,
    created_at: "2024-01-13T10:00:00Z",
    updated_at: "2024-01-13T10:00:00Z",
    lessons: createMockLessons(13, 14),
    total_lessons: 14,
    total_enrollments: 18760
  },
  {
    id: 14,
    title: "Data Science with Python",
    description: "Learn data science fundamentals using Python and popular libraries",
    instructor: mockInstructors[3],
    category: "programming",
    difficulty: "intermediate",
    thumbnail: undefined,
    created_at: "2024-01-17T10:00:00Z",
    updated_at: "2024-01-17T10:00:00Z",
    lessons: createMockLessons(14, 32),
    total_lessons: 32,
    total_enrollments: 23450
  },
  {
    id: 15,
    title: "Digital Marketing Fundamentals",
    description: "Comprehensive introduction to digital marketing strategies",
    instructor: mockInstructors[4],
    category: "marketing",
    difficulty: "beginner",
    thumbnail: undefined,
    created_at: "2024-01-21T10:00:00Z",
    updated_at: "2024-01-21T10:00:00Z",
    lessons: createMockLessons(15, 20),
    total_lessons: 20,
    total_enrollments: 19870
  }
];

// Combine all courses
export const allMockCourses: Course[] = [...mockCourses, ...additionalMockCourses];

// Generate remaining courses with proper structure
export const generateRemainingCourses = (): Course[] => {
  const remainingCourses: Course[] = [];
  const additionalInstructors: User[] = [
    {
      id: 11,
      username: "sophie_turner",
      email: "sophie.turner@example.com",
      first_name: "Sophie",
      last_name: "Turner",
      profile: {
        user_type: "instructor",
        bio: "Digital photography expert and creative professional",
        profile_picture: undefined,
        date_of_birth: "1986-05-20",
        phone_number: "+1-555-0133",
        created_at: "2020-01-09T10:00:00Z",
        updated_at: "2024-01-09T10:00:00Z"
      }
    },
    {
      id: 12,
      username: "alex_rivera",
      email: "alex.rivera@example.com",
      first_name: "Alex",
      last_name: "Rivera",
      profile: {
        user_type: "instructor",
        bio: "E-commerce strategist and business consultant",
        profile_picture: undefined,
        date_of_birth: "1989-12-08",
        phone_number: "+1-555-0134",
        created_at: "2020-01-23T10:00:00Z",
        updated_at: "2024-01-23T10:00:00Z"
      }
    }
  ];
  
  const allInstructors = [...mockInstructors, ...additionalInstructors];
  const categories = ["programming", "design", "business", "marketing", "lifestyle", "music"];
  const difficulties = ["beginner", "intermediate", "advanced"];
  
  const courseTitles = [
    "Digital Photography Mastery", "E-commerce Business Strategy", "Financial Planning and Analysis",
    "Flutter App Development", "Game Development with Unity", "Guitar for Beginners",
    "HTML and CSS Fundamentals", "iOS App Development", "JavaScript Fundamentals",
    "Leadership and Management", "Machine Learning with Python", "Marketing Analytics",
    "Node.js Backend Development", "Personal Finance Management", "Piano for Beginners",
    "Product Management Fundamentals", "Python Programming Basics", "React Native Development",
    "SEO Optimization Strategies", "Social Media Marketing", "UI/UX Design Principles",
    "Vue.js Framework Mastery", "Web Design Fundamentals"
  ];

  for (let i = 16; i <= 38; i++) {
    const title = courseTitles[i - 16];
    const instructor = allInstructors[Math.floor(Math.random() * allInstructors.length)];
    const category = categories[Math.floor(Math.random() * categories.length)];
    const difficulty = difficulties[Math.floor(Math.random() * difficulties.length)] as 'beginner' | 'intermediate' | 'advanced';
    const total_lessons = 12 + Math.floor(Math.random() * 20);
    const total_enrollments = 5000 + Math.floor(Math.random() * 20000);

    remainingCourses.push({
      id: i,
      title,
      description: `Comprehensive course on ${title.toLowerCase()}`,
      instructor,
      category,
      difficulty,
      thumbnail: undefined,
      created_at: new Date(2024, 0, i).toISOString(),
      updated_at: new Date(2024, 0, i).toISOString(),
      lessons: createMockLessons(i, total_lessons),
      total_lessons,
      total_enrollments
    });
  }

  return remainingCourses;
};

export const completeMockCourses: Course[] = [
  ...allMockCourses,
  ...generateRemainingCourses()
].sort((a, b) => a.title.localeCompare(b.title)); // Sort alphabetically
